import { Injectable } from '@angular/core';
import {
  NgEntityService,
  NgEntityServiceConfig,
} from '@datorama/akita-ng-entity-service';

import { CategoryStore, CategoryState } from './category.store';

@NgEntityServiceConfig({
  resourceName: 'categories',
})
@Injectable()
export class CategoryService extends NgEntityService<CategoryState> {
  constructor(protected store: CategoryStore) {
    super(store);
  }
}
